export default {
  title: 'Dostępność rezerwacji',
};
